import React, { useEffect, useState } from 'react';
import { Spinner } from "reactstrap";
import { useParams, useSearchParams } from "react-router-dom";

function ThreatList() {
  const [threats, setThreats]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const { agent }               = useParams();
  const [searchParams]          = useSearchParams();
  const days                    = searchParams.get("days");
  const API_BASE_URL            = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchThreats = async () => {
      setLoading(true);
      try {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const headers  = {
          "Content-Type": "application/json",
          ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
        };
        const url = agent === "All"
          ? `${API_BASE_URL}/threats/threat-mapping?days=${days || ''}`
          : `${API_BASE_URL}/threats/threat-mapping/${agent}?days=${days || ''}`;
        const response = await fetch(url, { headers });
        const data     = await response.json();
        if (data.success) setThreats(data.data.slice(0, 5));
      } catch (err) {
        console.error("Error fetching threats:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchThreats();
    // eslint-disable-next-line
  }, [agent, days]);

  const cols = ["Agent", "Total Threats", "Critical", "High"];

  return (
    <div style={{ marginBottom: 28 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
        <div style={{ width: 4, height: 20, background: "#FF5B00", borderRadius: 2, flexShrink: 0 }} />
        <h6 style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#1f2937", textTransform: "uppercase", letterSpacing: "0.05em" }}>
          Threat Overview
        </h6>
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, overflow: "hidden" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "2rem", color: "#9ca3af", fontSize: 13 }}>
            <Spinner size="sm" style={{ marginRight: 8, color: "#FF5B00" }} />
            Loading threats...
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f9fafb" }}>
                {cols.map(h => (
                  <th key={h} style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #e5e7eb" }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {threats.length > 0 ? threats.map((item, i) => (
                <tr key={`${item.agent_name}-${i}`} style={{ borderBottom: "1px solid #f3f4f6", background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                  <td style={{ padding: "10px 16px", fontWeight: 600, color: "#1f2937" }}>{item.agent_name}</td>
                  <td style={{ padding: "10px 16px", color: "#374151" }}>
                    <span style={{ fontWeight: 700, color: "#FF5B00" }}>{item.total_threats}</span>
                  </td>
                  <td style={{ padding: "10px 16px" }}>
                    <span style={{ display: "inline-block", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 20, background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca" }}>
                      {item.critical_threats}
                    </span>
                  </td>
                  <td style={{ padding: "10px 16px" }}>
                    <span style={{ display: "inline-block", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 20, background: "#fff7ed", color: "#ea580c", border: "1px solid #fed7aa" }}>
                      {item.high_threats}
                    </span>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="4" style={{ padding: "2rem", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>
                    No threat data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ThreatList;
